var map = {
	"./daily.svg": "0f23",
	"./dashboard.svg": "f782",
	"./data_paint.svg": "c394",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./full_outside.svg": "f318",
	"./halfyear.svg": "4ef5",
	"./home_news.svg": "27af",
	"./icon_dashboard_dataPaint.svg": "ada0",
	"./icon_dashboard_list.svg": "d02d",
	"./icon_dashboard_publishTask.svg": "d284",
	"./icon_dashboard_riskManage.svg": "916c",
	"./icon_dashboard_warning.svg": "8178",
	"./link.svg": "18f0",
	"./message.svg": "47ff",
	"./month.svg": "a3c6",
	"./nested.svg": "dcf8",
	"./out_side.svg": "0eea",
	"./password.svg": "2a3d",
	"./profressional.svg": "440b",
	"./publish_task.svg": "ce34",
	"./quarter.svg": "707b",
	"./risk_icon.svg": "3ee2",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f",
	"./warning_screen.svg": "cd94",
	"./we_media.svg": "f8a8",
	"./week.svg": "42f7",
	"./wordcloud.svg": "f86e",
	"./year.svg": "5bf5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";